
























































import { Component, Vue } from 'vue-property-decorator';
import LoadingContent from '@/components/LoadingContent.vue';
import GallerySection from './GallerySection.vue';
import GalleryKnife from './GalleryKnife.vue';
import { SectionData, KnifeData } from './GalleryModels';
import { getMultipleAttempts } from './Utils';

@Component({
  components: {
    LoadingContent,
    GallerySection,
    GalleryKnife,
  }
})
export default class Gallery extends Vue {

  private sections: SectionData[] = [];

  private isGettingSections = false;

  private getSectionsError = false;

  private openedSectionsIndices: number[] = [];

  get openedSectionIds(): (string|number)[] {
    return this.openedSectionsIndices.map(index => this.sections[index]?.id ?? 0);
  }

  mounted() {
    this.getSections();
  }

  private getSections() {
    this.sections = [];
    this.isGettingSections = true;
    this.getSectionsError = false;
    getMultipleAttempts(this.$axios, process.env.VUE_APP_SECTIONS_API)
      .then((response) => {
        this.isGettingSections = false;
        this.sections = response.data;
        // If only one section, automatically open it
        if (this.sections.length == 1 && this.openedSectionsIndices.length == 0) {
          this.openedSectionsIndices.push(0);
        }
      }).catch((/* reason */) => {
        this.isGettingSections = false;
        this.getSectionsError = true;
      });
  }

  /**
   * Is the dialog displayed.
   */
  private dialog = false;

  /**
   * The selected knife data.
   */
  private selectedKnife: KnifeData|null = null;

  private selectKnife(knife: KnifeData) {
    this.selectedKnife = knife;
    this.dialog = true;
  }

  private unselectKnife() {
    this.selectedKnife = null;
    this.dialog = false;
  }

}
